import { render, staticRenderFns } from "./SyncButton.vue?vue&type=template&id=37769a10&"
import script from "./SyncButton.vue?vue&type=script&lang=js&"
export * from "./SyncButton.vue?vue&type=script&lang=js&"
import style0 from "./SyncButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports